module.exports = __webpack_public_path__ + "img/tf.59230d93.svg";